class ReserveProduct extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    this.form = this.querySelector('form');
    this.successMessage = this.querySelector('[id^="ReserveSuccess"]');
    this.errorMessage = this.querySelector('[id^="ReserveError"]');
    this.submitButton = this.form?.querySelector('button[type="submit"]');
    
    // Ensure messages are hidden on initialization
    this.resetMessages();
    
    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
    
    // Listen for modal open events to reset messages
    const modal = this.closest('modal-dialog');
    if (modal) {
      // Use MutationObserver to watch for 'open' attribute changes
      this.modalObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            if (modal.hasAttribute('open')) {
              // Small delay to ensure modal is fully opened
              setTimeout(() => {
                this.resetMessages();
              }, 10);
            }
          }
        });
      });
      this.modalObserver.observe(modal, { attributes: true, attributeFilter: ['open'] });
      
      // Also listen for when modal is shown via the show method
      const originalShow = modal.show.bind(modal);
      modal.show = (opener) => {
        originalShow(opener);
        setTimeout(() => {
          this.resetMessages();
        }, 10);
      };
    }
  }
  
  disconnectedCallback() {
    if (this.modalObserver) {
      this.modalObserver.disconnect();
    }
  }
  
  resetMessages() {
    if (this.successMessage) {
      this.successMessage.setAttribute('hidden', '');
      this.successMessage.style.display = 'none';
    }
    if (this.errorMessage) {
      this.errorMessage.setAttribute('hidden', '');
      this.errorMessage.style.display = 'none';
    }
  }

  async handleSubmit(event) {
    event.preventDefault();

    // Hide previous messages
    this.resetMessages();

    if (!this.form) {
      this.showError('Er is iets misgegaan. Probeer het later opnieuw.');
      return;
    }

    // Get form data
    const formData = new FormData(this.form);
    const data = {
      name: formData.get('contact[name]'),
      email: formData.get('contact[email]'),
      phone: formData.get('contact[phone]')
    };

    // Basic validation
    if (!data.name || !data.email || !data.phone) {
      this.showError('Vul alle velden in.');
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data.email)) {
      this.showError('Voer een geldig e-mailadres in.');
      return;
    }

    // Disable submit button
    if (this.submitButton) {
      this.submitButton.disabled = true;
      this.submitButton.textContent = 'Bezig met verzenden...';
    }

    try {
      const response = await fetch(this.form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'text/html'
        }
      });

      if (!response.ok) {
        throw new Error('Request failed');
      }

      this.showSuccess();
      this.form.reset();

      // Re-enable submit button
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.textContent = 'Bekijk in de winkel';
      }

      // Optionally close modal after 3 seconds
      setTimeout(() => {
        const modal = this.closest('modal-dialog');
        if (modal) {
          modal.hide();
        }
      }, 3000);
    } catch (error) {
      this.showError('Er is een fout opgetreden. Probeer het later opnieuw.');
    }
  }

  showSuccess() {
    // Always hide error first
    if (this.errorMessage) {
      this.errorMessage.setAttribute('hidden', '');
      this.errorMessage.style.display = 'none';
    }
    // Then show success
    if (this.successMessage) {
      this.successMessage.removeAttribute('hidden');
      this.successMessage.style.display = 'flex';
      this.successMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  showError(message) {
    // Always hide success first
    if (this.successMessage) {
      this.successMessage.setAttribute('hidden', '');
      this.successMessage.style.display = 'none';
    }
    // Then show error
    if (this.errorMessage) {
      const errorText = this.errorMessage.querySelector('p');
      if (errorText) {
        errorText.textContent = message;
      }
      this.errorMessage.removeAttribute('hidden');
      this.errorMessage.style.display = 'flex';
      this.errorMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    
    // Re-enable submit button
    if (this.submitButton) {
      this.submitButton.disabled = false;
      this.submitButton.textContent = 'Bekijk in de winkel';
    }
  }
}

customElements.define('reserve-product', ReserveProduct);

// Initialize reserve product forms when modals are opened/closed
document.addEventListener('DOMContentLoaded', () => {
  // Reset forms when modal closes
  document.body.addEventListener('modalClosed', () => {
    const reserveModals = document.querySelectorAll('modal-dialog.reserve-modal');
    reserveModals.forEach(modal => {
      const form = modal.querySelector('form');
      const reserveProduct = modal.querySelector('reserve-product');
      
      if (form) {
        form.reset();
      }
      if (reserveProduct && typeof reserveProduct.resetMessages === 'function') {
        reserveProduct.resetMessages();
      }
    });
  });
  
  // Ensure messages are hidden when page loads and when modals open
  const ensureMessagesHidden = () => {
    const reserveProducts = document.querySelectorAll('reserve-product');
    reserveProducts.forEach(reserveProduct => {
      if (typeof reserveProduct.resetMessages === 'function') {
        reserveProduct.resetMessages();
      } else {
        // Fallback: directly hide messages if resetMessages doesn't exist yet
        const successMsg = reserveProduct.querySelector('[id^="ReserveSuccess"]');
        const errorMsg = reserveProduct.querySelector('[id^="ReserveError"]');
        if (successMsg) {
          successMsg.setAttribute('hidden', '');
          successMsg.style.display = 'none';
        }
        if (errorMsg) {
          errorMsg.setAttribute('hidden', '');
          errorMsg.style.display = 'none';
        }
      }
    });
  };
  
  ensureMessagesHidden();
  
  // Also check when modals are opened
  const observer = new MutationObserver(() => {
    ensureMessagesHidden();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

